import { DefaultTable } from "../Components/DefaultTable";
import { SeeAll } from "../Components/SeeAll";
import { dashboadBuyandSellcolumns } from "./Column";
import DashboardBuyandSellOfferData from "./DashboardBuyandSellOfferData";
import { BuyandSellOfferTableModals } from "./BuyandSellOfferTableModals";
import { LoadingMode } from "../Components/LoadingMode";
import { useNavigate } from "react-router-dom";

export const DashboardBuyandSellTable = () => {
  const {
    buyandSellOfferDataArray,
    openModal,
    handleOpenandCloseModal,
    offerDetails,
    cxId,
  } = DashboardBuyandSellOfferData();
  const navigate = useNavigate();
  const handleNav = () => {
    navigate("/tradecurrency/p2p/buy");
  };

  return (
    <div className="flex flex-col gap-4">
      <div onClick={handleNav}>
        <SeeAll name="Buy and Sell Offers" seeAll={true} />
      </div>
      {!!buyandSellOfferDataArray?.length ? (
        <div className="overflow-x-auto">
          <DefaultTable
            columns={dashboadBuyandSellcolumns}
            data={buyandSellOfferDataArray}
          />
        </div>
      ) : (
        // <LoadingMode />
        <div className="w-full">
          <div className="w-full h-full flex items-center justify-center">
            <p className="text-lg text-center">No data available</p>
          </div>
        </div>
      )}
      <BuyandSellOfferTableModals
        openModal={openModal}
        handleOpenandCloseModal={handleOpenandCloseModal}
        offerDetails={offerDetails}
        cxId={cxId}
      />
    </div>
  );
};
